module.exports = __webpack_public_path__ + "fonts/Nunito-SemiBold.ec1377dc.ttf";